import { ExameRealizadoPreNatalConsolidadoStatusEnum, FaixaEtariaEnum } from 'graphql/types.generated'
import { isEmpty } from 'util/validation/Util'

import { AcompanhamentoCondicaoSaudeFormModel } from './model/model-acompanhamentoCondicaoSaude'

export const labelByStatus = (status?: ExameRealizadoPreNatalConsolidadoStatusEnum): string =>
  status ? statusToText[status] : statusInvalidoText

const statusToText: Record<ExameRealizadoPreNatalConsolidadoStatusEnum, string> = {
  [ExameRealizadoPreNatalConsolidadoStatusEnum.SIM]: 'Sim',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO]: 'Não',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO_SE_APLICA]: 'Não se aplica',
}

const statusInvalidoText = '-'

export function contarFiltrosAvancadosAplicados(filter: AcompanhamentoCondicaoSaudeFormModel) {
  const currentFiltrosAplicados = {
    periodoUltimoAtendimento:
      filter?.periodoUltimoAtendimento &&
      (filter.periodoUltimoAtendimento.startDate || filter.periodoUltimoAtendimento.endDate)
        ? filter.periodoUltimoAtendimento
        : null,
    grupoCondicao: !isEmpty(filter?.grupoCondicao) ? filter?.grupoCondicao : null,
    problemasCondicoes: !isEmpty(filter?.problemasCondicoes) ? filter?.problemasCondicoes : null,
    ativoListaProblema: filter?.ativoListaProblema || null,
    naoIncluidoListaProblema: filter?.naoIncluidoListaProblema || null,
    sexo: !isEmpty(filter?.sexo) ? filter?.sexo : null,
    tipoFaixaEtaria:
      filter?.tipoFaixaEtaria && filter.tipoFaixaEtaria !== FaixaEtariaEnum.OUTRA ? filter?.tipoFaixaEtaria : null,
    faixaEtariaRange: filter?.faixaEtariaRange ?? null,
    identidadeGenero: !isEmpty(filter?.identidadeGenero) ? filter?.identidadeGenero : null,
    ivcf: filter?.ivcf ?? undefined,
    racaCor: filter?.racaCor ?? null,
  }

  const countFiltrosAplicados = Object.values(currentFiltrosAplicados).reduce((count, value) => {
    if (Array.isArray(value) && value.length > 0) {
      return count + value.length
    }
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.values(value).some((v) => Array.isArray(v) && v.length > 0)
    ) {
      return count + Object.values(value).reduce((acc, v) => (Array.isArray(v) ? acc + v.length : acc), 0)
    }
    if (!Array.isArray(value) && !isEmpty(value)) {
      return count + 1
    }
    return count
  }, 0)

  return countFiltrosAplicados
}

export function getProcedimentosConsideradosTooltipText(
  procedimentos: string[],
  title?: { plural: string; singular: string }
): string {
  if (isEmpty(procedimentos)) return ''

  const { plural = 'Procedimentos considerados', singular = 'Procedimento considerado' } = title ?? {}
  const actualTitle = procedimentos.length > 1 ? plural : singular

  return `${actualTitle}:\n${procedimentos.join('\n\n')}`
}
